<template>
  <!-- <LoadingIndicator :loading="isLoading" v-if="isLoading" id="loading-bar" /> -->
  <v-row id="retirement-calculator" class="mb-16">
    <v-col cols="12" sm="12" md="12" lg="8" class="px-0 mt-0 pt-0 pb-0">
      <v-card height="100%">
        <v-col cols="12" sm="12" md="12" class="text-h5 retirement-title titlebox font-weight-bold">
          <v-card-title
            ><h2 class="text-h2">{{ $t('L_calculator_retirement') }}</h2></v-card-title
          >
        </v-col>
        <v-row class="rule-of-thumb-card d-flex align-center justify-center">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-img
              :src="ruleOfThumbIcon"
              height="60px"
              width="80px"
              alt="rule"
              :class="$vuetify.display.smAndUp ? 'mr-3' : ''"
            />
            <v-card-text>
              <div class="text-h4">
                {{ $t('L_calculator_rule_of_thumb') }}
              </div>
              <div class="body-1">{{ $t('L_calculator_rule_of_thumb_desc') }}</div>
            </v-card-text>
          </v-col>
        </v-row>
        <v-card-text class="text-h4">
          {{ $t('L_calculator_intro') }}
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-row class="justify-center">
            <v-col cols="12" sm="7" md="8" lg="8" class="d-flex align-center px-0 pt-0 pb-0">
              <div class="text-subtitle-1 font-weight-medium">
                {{ $t('L_calculator_dob') }}
              </div>
            </v-col>
            <v-col cols="0" sm="1" md="1" lg="1" class="px-0" />
            <v-col cols="12" sm="4" md="3" lg="3" class="px-0 ma-0">
              <OnexDatePicker
                id="birth_date"
                data-comp-id="birth_date"
                type="dob"
                :label="$t('L_Required_Fields')"
                :date-format="dobFormatLanguage"
                :min="minDateCheck"
                :max="maxDateCheck"
                bg-color="white"
                required
                sensitive
                :model-value="dateOfBirth"
                @update:modelValue="onDateUpdate"
                :key="$i18n.locale"
              />
              <span v-if="!isDobValid" class="text-error text-caption ma-0 pa-0">
                {{ dobError }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-row>
            <v-col cols="12" sm="7" md="8" lg="8" class="px-0 pt-0 pb-0 pl-0 pr-0">
              <div class="text-subtitle-1 font-weight-medium">
                {{ $t('L_calculator_current_age') }}
              </div>
            </v-col>
            <v-col cols="0" sm="1" md="1" lg="1" class="px-0 pt-0 pb-0" />
            <v-col
              cols="12"
              sm="4"
              md="3"
              lg="3"
              class="ma-0 mt-3 px-0 pt-0 pb-0 centered-input font-size--16 more-padding text-center font-weight-medium"
            >
              {{ currentAge }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-row class="justify-center">
            <v-col
              cols="12"
              sm="7"
              md="8"
              lg="8"
              class="d-flex align-start justify-start text-left px-0 pt-0 pb-0"
            >
              <div
                class="text-subtitle-1 font-weight-medium"
                :class="$vuetify.display.xsOnly ? 'mt-0' : 'mt-8'"
              >
                {{ $t('L_calculator_age') }}
              </div>
            </v-col>
            <v-col cols="0" sm="1" md="1" lg="1" class="px-0 pt-0 pb-0" />
            <v-col
              cols="12"
              sm="4"
              md="3"
              lg="3"
              v-if="scenario?.retirement?.age"
              class="px-0 pt-0 pb-0"
            >
              <OnexText
                id="retirement-calculator-age-input"
                v-model="scenario.retirement.age"
                class="ma-0 pa-0 text-center font-size--24 more-padding"
                single-line
                style="text-align: center !important"
                bg-color="white"
                @change="
                  validateAge();
                  calculate($event);
                "
                label=""
                type="number"
                hide-details
                :aria-label="'Calculated retirement age'"
                pattern="[0-9]*"
                inputmode="numeric"
              />
              <span v-if="!isAgeValid" class="text-error text-caption ma-0 pa-0">
                {{ ageError }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="pt-0 pb-0" :class="$vuetify.display.xs ? 'mt-8' : 'mt-0'">
          <v-row class="justify-center">
            <v-col
              cols="12"
              sm="7"
              md="8"
              lg="8"
              class="text-subtitle-1 font-weight-medium align-center d-flex px-0 pt-0 pb-0"
            >
              {{ $t('L_calculator_annual_income') }}
            </v-col>
            <v-col cols="0" sm="1" md="1" lg="1" class="px-0 pt-0 pb-0" />
            <v-col cols="12" sm="4" md="3" lg="3" class="px-0 pt-0 pb-0">
              <CurrencyDisplay
                v-model="scenario.currentIncome"
                @change="calculate('goalpct')"
                label-id="currentIncome"
                class="more-padding"
                color="white"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row class="justify-center">
            <v-col cols="12" sm="12" md="12" lg="12" class="px-0 pt-0 pb-0">
              <div class="font-weight-medium text-subtitle-1">
                {{ $t('L_calculator_monthly_income') }}
              </div>
              <div>{{ $t('L_calculator_expect_social_security') }}</div>
              <div class="estimate-social-security d-flex align-center">
                <span v-if="isCanada" class="link" @click="openDocument('SSN')">
                  {{ $t('L_calculator_estimate_social_security_ca') }}
                </span>
                <span v-else class="link" @click="openDocument('SSN')">
                  {{ $t('L_calculator_estimate_social_security_us') }}
                </span>
                <v-icon
                  @click="openDocument('SSN')"
                  color="blue-darken-2 ml-1"
                  size="16"
                  :icon="mdiLaunch"
                />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row class="ma-0 pa-0 align-center justify-end">
            <v-col cols="12" sm="3" md="3" lg="3" class="text-center pt-0 pb-0">
              <div>
                <OnexText
                  label=""
                  inputmode="numeric"
                  id="percentage-guidence-calculator"
                  :key="isFinite(scenario.incomeGoalPct) ? 'pct-finite' : 'pct-infinite'"
                  :model-value="
                    scenario.incomeGoalPct != null && isFinite(scenario.incomeGoalPct)
                      ? String(scenario.incomeGoalPct)
                      : ''
                  "
                  @update:modelValue="scenario.incomeGoalPct = Number($event)"
                  type="number"
                  bg-color="white"
                  class="text-right font-size--24 pb-0 more-padding"
                  @change="
                    validatePct();
                    calculate('goalpct');
                  "
                  suffix="%"
                  hide-details
                  :aria-label="'Percent of your income'"
                />
              </div>
              <div class="unit pb-4">
                {{ $t('L_calculator_of_your_income_unit') }}
              </div>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" class="text-center px-0 pt-0 pb-6">
              <div>&nbsp;</div>
              <div>{{ $t('L_calculator_or') }}</div>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" class="text-center px-0 pt-0 pb-0">
              <CurrencyDisplay
                v-model="scenario.incomeGoal"
                @change="
                  validateAmt();
                  calculate('goal');
                "
                class="pa-0 more-padding"
                label-id="incomeGoal"
                :hide-details="hideDetails"
              />
              <div class="unit">
                {{ $t('L_calculator_per_month_unit') }}
              </div>
            </v-col>
            <v-col cols="12" sm="0" md="0" lg="0" class="px-0 pt-0 pb-0" />
          </v-row>
          <v-row v-if="!isPctValid" class="align-content-start justify-end text-left">
            <v-col cols="12" sm="8" md="8" lg="8" class="px-0 pt-0 pb-0">
              <span class="text-error text-caption">{{ $t('L_calculator_income_pct_error') }}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="account-list">
          <v-row class="justify-start">
            <v-col
              cols="12"
              sm="9"
              md="9"
              lg="9"
              class="font-weight-medium text-subtitle-1 px-0 pt-0 pb-0"
            >
              {{ $t('L_calculator_saved_retiremment') }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="account-list pt-0 pb-4">
          <v-row>
            <v-col cols="0" sm="1" md="1" lg="1" />
            <v-col cols="2" sm="1" md="1" lg="1">
              <v-img width="28px" height="25px" :src="savingsIcon" />
            </v-col>
            <v-col cols="5" sm="7" md="7" lg="6" class="font-weight-medium d-flex align-center">
              {{ $t('L_calculator_saved_retiremment_primerica') }}
            </v-col>
            <v-col
              cols="4"
              sm="2"
              md="2"
              lg="3"
              class="text-right font-size--16 font-weight-medium"
            >
              <span v-if="scenario?.retirement?.savings">{{
                $n(scenario.retirement.savings, 'currencyNoCents', 'en-US')
              }}</span>
              <span v-else>$0</span>
            </v-col>
            <v-col cols="1" sm="0" md="1" lg="1" />
          </v-row>
          <v-row class="row justify-center">
            <v-col cols="0" class="pt-0 pb-0" />
            <v-col
              cols="12"
              sm="12"
              md="11"
              lg="11"
              class="pt-0 pb-0"
              v-if="scenario?.retirement?.accounts?.length > 0"
            >
              {{ $t('L_calculator_saved_retiremment_primerica_intro') }}
              <span class="link" @click="viewMyInvestments()">{{
                $t('L_calculator_view_my_investments')
              }}</span>
            </v-col>
            <v-col cols="0" sm="2" md="2" lg="3" class="pt-0 pb-0" />
          </v-row>
        </v-card-text>
        <v-card-text class="account-list" v-if="scenario.retirement.accounts">
          <v-row
            id="retirement-calculator-accounts"
            v-for="account in scenario.retirement.accounts"
            :key="`retirement-calculator-account-` + account.number"
            class="justify-center"
          >
            <v-col cols="0" sm="1" md="1" lg="1" class="pt-0 pb-0" />
            <v-col cols="7" sm="8" md="7" lg="7" class="text-subtitle-1 pt-0 pb-0">
              <v-checkbox
                color="primary"
                class="ma-0 pa-0"
                v-model="selectedAccounts"
                @input="calculate"
                :value="account.number"
                :aria-labelledby="'selected account'"
                title="'selected account'"
              >
                <template v-slot:label>
                  <div class="blackText">
                    {{ account.productType }}
                    {{ account.number }}<br />
                    {{ account.type }}
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col
              cols="4"
              sm="2"
              md="3"
              lg="3"
              class="text-right font-size--16 font-weight-medium"
            >
              <span v-if="account.balance">{{
                $n(account.balance, 'currencyNoCents', 'en-US')
              }}</span>
              <span v-else>$0</span>
            </v-col>
            <v-col cols="1" sm="1" md="1" lg="1" class="pt-0 pb-0" />
          </v-row>
          <v-row class="justify-left">
            <v-col cols="0" sm="1" md="1" lg="1" />
            <v-col
              cols="12"
              sm="11"
              md="11"
              lg="11"
              v-if="scenario?.retirement?.accounts?.length > 0"
            >
              <span v-if="isCanada"
                >{{ $t('L_important_disclosures_ca') }}
                <span class="link" @click="openDocument('Disclosure')">
                  {{ $t('L_here') }}
                </span>
              </span>
              <div v-else>
                <p>
                  <span
                    >{{ $t('L_important_disclosures_us') }}
                    <span class="link" @click="openDocument('Disclosure')">
                      {{ $t('L_important_disclosures') }}
                    </span>
                  </span>
                </p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="account-list pt-4 pb-0">
          <v-row>
            <v-col cols="0" sm="1" md="1" lg="1" class="pt-0 pb-0" />
            <v-col cols="2" sm="1" md="1" lg="1" class="pt-0 pb-0">
              <v-img width="28px" height="25px" :src="bankIcon" />
            </v-col>
            <v-col cols="10" sm="5" md="6" lg="6" class="font-weight-medium align-center pt-0 pb-0">
              {{ $t('L_calculator_saved_retiremment_other') }}
            </v-col>
            <v-col cols="0" sm="1" md="1" lg="1" class="pt-0 pb-0" />
            <v-col cols="12" sm="4" md="3" lg="3" class="text-right pt-0 pb-0">
              <CurrencyDisplay
                v-model="scenario.otherSavings"
                @change="calculate"
                label-id="otherSavings"
                class="more-padding"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="account-list mr-0">
          <v-row class="justify-space-around">
            <v-col
              cols="12"
              sm="7"
              md="8"
              lg="8"
              class="text-subtitle-1 font-weight-medium d-flex align-center px-0"
            >
              {{ $t('L_calculator_saving_retirement') }}
            </v-col>
            <v-col cols="0" sm="1" md="1" lg="1" class="px-0 pt-0 pb-0" />
            <v-col cols="12" sm="4" md="3" lg="3">
              <CurrencyDisplay
                id="retirement-calculator-currency-display"
                v-model="scenario.monthlySavings"
                @change="calculate"
                label-id="monthlySavings"
                class="more-padding"
              />
            </v-col>
            <v-col cols="0" sm="0" md="0" lg="0" />
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-row class="justify-center">
            <v-col cols="12" sm="12" md="12" class="text-subtitle-1 font-weight-medium px-0 pb-0">
              {{ $t('L_calculator_not_saving_enough') }}
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="12" sm="12" md="12" class="px-0 subtitle-1 pt-0">
              {{ $t('L_calculator_help_options') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col ms12 sm="12" md="12" lg="12" class="pt-0 pb-0">
              <ul>
                <li>{{ $t('L_calculator_help_options_monthly_saving') }}</li>
                <li>{{ $t('L_calculator_help_options_age') }}</li>
                <li>{{ $t('L_calculator_help_options_income_goal') }}</li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Expantion -->
    <v-col
      id="expandable-panel"
      cols="12"
      sm="12"
      md="12"
      lg="4"
      class="full-length bg-grey-lighten-3"
      v-if="hidePredictionDetails"
    >
      <v-card color="grey-lighten-3" flat class="text-center">
        <v-card-text class="px-0 text-subtitle-1 font-weight-medium view-mode-details">
          <div
            v-if="!expandedPrediction"
            @click="expandedPrediction = true"
            id="expandable-panel-mode-details"
          >
            {{ $t('L_calculator_view_details') }}
            <v-icon size="large" color="#063562" :icon="mdiChevronDown" />
          </div>
          <div v-else @click="expandedPrediction = false">
            {{ $t('L_calculator_hide_details') }}
            <v-icon size="large" color="#063562" :icon="mdiChevronUp" />
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Right side of page -->
    <v-col cols="12" sm="12" md="12" lg="4" class="full-length bg-grey-lighten-3 pl-0 pr-0">
      <v-card v-if="expandedPrediction" color="grey-lighten-3" flat class="text-center">
        <v-row class="justify-center">
          <v-col
            wrap
            cols="12"
            sm="3"
            md="3"
            lg="12"
            align-self="start"
            class="d-flex align-center flex-column"
          >
            <v-card-text class="text-h6 font-weight-medium pt-3 pl-0 px-0">
              <h2>{{ $t('L_calculator_retirement_goal') }}</h2>
            </v-card-text>
            <div class="chart">
              <Achievement />
            </div>
            <div class="chart">
              <ProgressCircle
                :progress="
                  projection.percentRetirementIncomeGoal > 100
                    ? 100
                    : projection.percentRetirementIncomeGoal
                "
                :size="12"
              />
            </div>
          </v-col>
          <v-col cols="12" sm="9" md="9" lg="12" class="px-0 pl-4 pr-4">
            <v-row class="justify-center">
              <v-col cols="12" sm="6" md="6" lg="12" class="pa-0">
                <v-card-text
                  class="ma-0 pa-0"
                  :class="[
                    $vuetify.display.md ? 'pt-8' : '',
                    $vuetify.display.width < 1280 ? 'pt-8' : '',
                  ]"
                >
                  {{ $t('L_calculator_projected_retirement_income') }}
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="16"
                lg="12"
                class="px-0 pt-0 pb-0 d-flex justify-center align-center"
              >
                <v-card-text class="d-flex justify-center align-center flex-column">
                  <v-col
                    cols="10"
                    sm="10"
                    md="10"
                    lg="10"
                    class="font-size--24 font-weight-medium pill-text-field"
                  >
                    {{ $n(projection.projectedRetirementIncome, 'currencyNoCents', 'en-US') }}
                    <span class="text-body-1">{{ $t('L_calculator_per_month') }}</span>
                  </v-col>
                  <p class="v-card-text mt-2 pa-0">{{ $t('L_calculator_based_on_savings') }}</p>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" sm="6" md="6" lg="12" class="pa-0 pb-0">
                <v-card-text>
                  <span v-if="isProjectionIncomeGoalPctUnder100">
                    {{
                      $t('L_calculator_monthly_income_goal', {
                        pct: projection.percentRetirementIncomeGoal.toFixed(0),
                      })
                    }}
                  </span>
                  <span v-else>
                    {{ $t('L_calculator_monthly_income_goal_over100') }}
                  </span>
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                lg="12"
                class="d-flex justify-center align-center pt-0"
              >
                <v-card-text class="d-flex justify-center align-center pa-0">
                  <v-col
                    cols="10"
                    sm="10"
                    md="10"
                    lg="10"
                    class="font-size--24 font-weight-medium pill-text-field"
                  >
                    <span v-if="scenario?.incomeGoal">{{
                      $n(scenario.incomeGoal, 'currencyNoCents', 'en-US')
                    }}</span>
                    <span v-else>$0</span>
                    <span class="text-body-1">{{ $t('L_calculator_per_month') }}</span>
                  </v-col>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" sm="6" md="6" lg="12" class="pa-0">
                <v-card-text class="font-weight-bold px-0 pt-8 pb-0">
                  {{ $t('L_calculator_financial_independence_number') }}
                  <v-tooltip location="top" max-width="200" open-on-click>
                    <template v-slot:activator="{ props }">
                      <v-icon
                        color="blue-darken-2"
                        size="16"
                        v-bind="props"
                        :icon="mdiHelpCircle"
                      />
                    </template>
                    <span>{{ $t('L_calculator_fin_tooltip') }}</span>
                  </v-tooltip>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="12" class="px-0 pt-0">
                <v-card-text>
                  <v-row class="justify-center">
                    <v-col
                      cols="10"
                      sm="10"
                      md="10"
                      lg="10"
                      class="font-size--24 font-weight-medium pill-text-field-red"
                    >
                      {{ $n(projection.summary.goal.savings, 'currencyNoCents', 'en-US') }} *
                    </v-col>
                  </v-row>
                  <div class="mt-2">
                    {{ $t('L_calculator_total_savings') }}
                  </div>
                </v-card-text>
                <v-card-text class="text-body-1 font-weight-medium justify-center px-0 mx-0">
                  <v-tooltip
                    max-width="200"
                    html="true"
                    open-on-click
                    :open-on-hover="false"
                    location="top"
                    close-delay="2000"
                  >
                    <template v-slot:activator="{ props }">
                      <span v-html="$t('L_calculator_how_calculate')" />
                      <v-icon
                        color="blue-darken-2 ml-1"
                        size="16"
                        v-bind="props"
                        :icon="mdiHelpCircle"
                      />
                    </template>
                    <div @click="openDocument('ImportantNote')">
                      <p v-html="$t('L_calculator_how_calculate_tooltip')"></p>
                    </div>
                  </v-tooltip>
                  <div v-if="!isTablet && !isMobile" class="ma-0 pa-0">
                    <div class="link" @click="openDocument('ImportantNote')">
                      {{ $t('L_calculator_view_important_notes') }}
                    </div>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card color="grey-lighten-2" flat class="text-center">
        <v-row class="justify-center">
          <v-col cols="12" sm="5" md="5" lg="12">
            <v-card-text v-if="!isTablet && !isMobile" class="text-subtitle-1 font-weight-medium">
              <v-row class="justify-center">
                <v-col cols="12" class="d-flex justify-center align-center ma-0 pa-0">
                  <v-img
                    v-if="isProjectionIncomeGoalPctUnder100"
                    :width="50"
                    :height="50"
                    :src="goalIcon"
                  />
                  <v-img v-else width="50px" height="50px" :src="congratsIcon" />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text
              v-if="isTablet || isMobile"
              class="px-0 text-subtitle-1 font-weight-medium ma-0"
            >
              <span class="link" @click="openDocument('ImportantNote')">
                {{ $t('L_calculator_view_important_notes') }}
              </span>
            </v-card-text>
            <div v-if="isProjectionIncomeGoalPctUnder100">
              <div v-if="expandedPrediction || isTablet">
                <v-card-text class="v-card-text font-weight-regular ma-0 pa-0">
                  {{ $t('L_calculator_to_meet_goal') }}
                </v-card-text>
                <v-card-text>
                  <v-row class="ma-0 pa-0 justify-center" id="projections">
                    <v-col
                      cols="10"
                      sm="10"
                      md="10"
                      lg="10"
                      class="font-size--24 font-weight-medium pill-text-field"
                    >
                      {{
                        $n(projection.summary.goal.additionalMonthly, 'currencyNoCents', 'en-US')
                      }}
                      <span class="text-body-1">{{ $t('L_calculator_per_month') }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
              <div v-else>
                <v-card-text class="text-subtitle-1 font-weight-regular ma-0 pa-0">
                  <p
                    v-html="
                      $t('L_calculator_to_meet_goal_short', {
                        amt: $n(
                          projection.summary.goal.additionalMonthly,
                          'currencyNoCents',
                          'en-US'
                        ),
                      })
                    "
                  />
                </v-card-text>
              </div>
            </div>
            <div v-else>
              <v-card-text class="text-subtitle-1 congratulations font-weight-medium ma-0 pa-0">
                {{ $t('L_calculator_congratulations') }}
              </v-card-text>
              <v-card-text class="text-subtitle-1 font-weight-regular congratulations">
                {{ $t('L_calculator_congratulations_desc') }}
              </v-card-text>
            </div>
          </v-col>
          <v-col cols="12" sm="5" md="5" lg="12" class="ma-0 pa-0">
            <div v-if="!isMobile || expandedPrediction">
              <div v-if="isProjectionIncomeGoalPctUnder100">
                <v-card-text v-if="isTablet" />
                <v-card-text class="text-subtitle-1 font-weight-bold ma-0">
                  {{ $t('L_calculator_ask_your_rep') }}
                </v-card-text>
              </div>
              <div v-else>
                <v-card-text class="text-subtitle-1 congratulations">
                  <div class="font-weight-medium">
                    {{ $t('L_calculator_if_retirement_needs') }}
                  </div>
                </v-card-text>
              </div>
            </div>
            <MyRep :rep-page="false" />
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="12" />
        </v-row>
      </v-card>
    </v-col>
    <EmbeddedViewer
      :title="document.title"
      :loading="document.loading"
      :content-type="document.type"
      :content-url="document.content"
      @close="document.content = ''"
    />
  </v-row>
</template>

<script lang="ts">
import Achievement from '@/components/Achievement/Achievement.vue';
import ProgressCircle from '@/components/ProgressCircle/ProgressCircle.vue';
import { currency } from '@/mixins/numbers';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import EmbeddedViewer from '@/components/EmbeddedViewer.vue';
import CurrencyDisplay from '../../policy/PolicyGuidanceCalculator/components/CurrencyDisplay.vue';
import { COUNTRIES } from '@/shared/models/constants.models';
import { mapActions, mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { differenceInYears, format, parseISO } from 'date-fns';
import { defineComponent, type ComponentOptions } from 'vue';

import ruleOfThumbIcon from '@/assets/investments/calculator/rule-of-thumb-icon.svg';
import savingsIcon from '@/assets/investments/calculator/savings-icon.svg';
import bankIcon from '@/assets/investments/calculator/bank-icon.svg';
import goalIcon from '@/assets/investments/calculator/goal-icon.svg';
import congratsIcon from '@/assets/investments/calculator/congrats-icon.svg';
import { formatDateFns } from '@/shared/util/formatters';
import { mdiLaunch, mdiHelpCircle, mdiChevronUp, mdiChevronDown } from '@mdi/js';
import MyRep from '@/modules/myRep/MyRep.vue';
import { DateFormats, OnexText, UILocale, OnexDatePicker } from '@primerica/onex-ui-lib';
import { minDateCheck, maxDateCheck } from '@/shared/utils/dateFormats';
import type { IInvestmentCalculatorScenarioRetirementAccount } from '@/shared/api/models.bff.ts';
import type { ICustomerStoreInvestmentsGroup } from '@/stores/customer/customerStore.model.ts';

const componentOptions: ComponentOptions = {
  name: 'GuidanceCalculator',
  emits: ['open'],
  mixins: [currency],
  data() {
    return {
      mdiLaunch,
      mdiHelpCircle,
      mdiChevronDown,
      mdiChevronUp,
      document: {
        title: '',
        content: '',
        type: '',
        loading: false,
      },
      selectedAccounts: [] as string[],
      hideDetails: true,
      isAgeValid: true,
      isPctValid: true,
      isDobValid: true,
      expandedPrediction: true,
      contactRep: false,
      sliderKey: 0,
      ageError: '',
      currentAge: '',
      dateOfBirth: null as Date | null,
      dobError: '',
      socialSecurityBenefits: '',
      ruleOfThumbIcon,
      savingsIcon,
      bankIcon,
      goalIcon,
      congratsIcon,
      differenceInYears,
    };
  },
  components: {
    Achievement,
    ProgressCircle,
    CurrencyDisplay,
    LoadingIndicator,
    EmbeddedViewer,
    MyRep,
    OnexText,
    OnexDatePicker,
  },
  computed: {
    ...mapState(usePolicyStore, ['policiesSortedByDate']),
    ...mapState(useCustomerStore, [
      'loading',
      'customerProfile',
      'investments',
      'investmentsSortedByDate',
    ]),
    ...mapState(useGlobalStore, ['getAgent', 'agents']),
    hasReps() {
      return this.agents?.length > 0;
    },
    isLoading() {
      return this.loading.retirementCalculator;
    },
    isCanada() {
      return this.customerProfile.country === COUNTRIES.CANADA;
    },
    dobFormatLanguage() {
      return this.$i18n.locale === UILocale.FR_CA.toString()
        ? DateFormats.DDMMYYYY
        : DateFormats.MMDDYYYY;
    },
    minDateCheck,
    maxDateCheck,
    projection() {
      return (
        this.investments.calculator?.projection || {
          projectedRetirementIncome: 0,
          percentRetirementIncomeGoal: 0,
          summary: {
            current: {
              monthly: 0,
            },
            goal: {
              shortfall: 0,
              savings: 0,
              additionalMonthly: 0,
            },
          },
        }
      );
    },
    scenario() {
      if (this.investments.calculator?.scenario) {
        const scenario = JSON.parse(JSON.stringify(this.investments.calculator.scenario));
        const dob = new Date(this.investments.calculator.scenario.dateOfBirth);

        this.currentAge = '' + differenceInYears(new Date(), dob);
        // Handling infinity for incomeGoalPct when currentIncome is 0
        if (this.investments.calculator.scenario.incomeGoalPct > 1000) {
          scenario.incomeGoalPct = null;
        }
        return scenario;
      }
      const accounts: IInvestmentCalculatorScenarioRetirementAccount[] = [];
      this.investments.groups?.forEach((group: ICustomerStoreInvestmentsGroup) => {
        group.accounts?.forEach((account) => {
          accounts.push({
            productType: account.productType,
            number: account.accountNumber,
            enabled: true,
            type: account.accountType,
            balance: account.endingValue,
          } as unknown as IInvestmentCalculatorScenarioRetirementAccount);
        });
      });
      return {
        currentIncome: 0,
        incomeGoal: 0,
        incomeGoalPct: 0,
        otherSavings: 0,
        monthlySavings: 0,
        scenarioId: -1,
        retirement: {
          accounts,
          savings: 0,
          age: 0,
        },
      };
    },
    hidePredictionDetails() {
      return this.isTablet || this.isMobile;
    },
    isProjectionIncomeGoalPctUnder100() {
      return this.projection.percentRetirementIncomeGoal <= 100;
    },
    isTablet() {
      return this.$vuetify.display.sm;
    },
    isMobile() {
      return this.$vuetify.display.xs;
    },
    isNotProd() {
      return ['dev', 'test'].includes(String(window.appConfig.env));
    },
  },
  methods: {
    ...mapActions(useCustomerStore, {
      getInvestmentCalculator: 'getInvestmentCalculator',
      contactRepresentative: 'contactRepresentative',
    }),
    calculate(state: string) {
      if (this.isAgeValid && this.isPctValid && this.isDobValid) {
        if (state === 'init') {
          this.scenario.retirement.accounts.forEach(
            (account: IInvestmentCalculatorScenarioRetirementAccount) =>
              this.selectedAccounts.push(account.number)
          );
        } else {
          const dob = this.dateOfBirth as Date;
          this.scenario.dateOfBirth = format(dob, 'yyyy-MM-dd');
          this.scenario.currentAge = differenceInYears(new Date(), dob);
          this.scenario.retirement.accounts = this.scenario.retirement.accounts.map(
            (account: IInvestmentCalculatorScenarioRetirementAccount) => {
              account.enabled = this.selectedAccounts.includes(account.number);
              return account;
            }
          );
        }
        if (state === 'goal') this.scenario.incomeGoalPct = 0;
        if (state === 'goalpct') this.scenario.incomeGoal = 0;
        this.scenario.incomeGoal = +this.scenario.incomeGoal;
        this.scenario.incomeGoalPct = +this.scenario.incomeGoalPct;
        this.scenario.otherSavings = +this.scenario.otherSavings;
        this.scenario.monthlySavings = +this.scenario.monthlySavings;
        this.scenario.currentIncome = +this.scenario.currentIncome;
        this.getInvestmentCalculator(this.scenario);
      }
    },
    openDocument(type: string) {
      this.document.type = 'application/pdf';
      if (type === 'ImportantNote') {
        this.document.title = this.$t('L_calculator_important_notes');
        this.document.content =
          this.scenario.retirement.age - this.scenario.currentAge <= 5
            ? `${window.appConfig.content_stack}${window.appConfig.investments.how_do_we_calculate.less5years}`
            : `${window.appConfig.content_stack}${window.appConfig.investments.how_do_we_calculate.over5years}`;
      } else if (type === 'SSN') {
        this.document.title = this.$t('L_calculator_social_security_benefit');
        this.document.content =
          this.customerProfile.country === COUNTRIES.CANADA
            ? window.appConfig.investments.social_security_benefits.ca
            : window.appConfig.investments.social_security_benefits.us;
      } else if (type === 'Disclosure') {
        this.document.title = this.$t('L_important_disclosures');
        if (this.customerProfile.country.toLowerCase() === 'ca') {
          this.document.content = `${window.appConfig.content_stack}${window.appConfig.investments.important_disclosures.ca}`;
        } else {
          this.document.content = `${window.appConfig.content_stack}${window.appConfig.investments.important_disclosures.us}`;
        }
      }
    },
    validateAge() {
      if (!this.scenario.retirement.age) {
        this.isAgeValid = false;
        this.ageError = this.$t('L_calculator_age_required');
      } else if (this.scenario.retirement.age <= this.currentAge) {
        this.isAgeValid = false;
        this.ageError = this.$t('L_calculator_age_less_error');
      } else if (this.scenario.retirement.age >= this.scenario.lifeExpectancy) {
        this.isAgeValid = false;
        this.ageError = this.$t('L_calculator_age_greater_error', {
          age: this.scenario.lifeExpectancy,
        });
      } else {
        this.isAgeValid = true;
        this.ageError = '';
      }
    },
    validatePct() {
      this.isPctValid = this.scenario.incomeGoalPct <= 1000;
    },
    validateDob() {
      if (!this.dateOfBirth) {
        this.isDobValid = false;
        this.dobError = this.$t('L_calculator_dob_required');
      } else {
        const age = differenceInYears(new Date(), this.dateOfBirth); // moment().diff(dob, 'years');
        if (age < 18) {
          this.isDobValid = false;
          this.dobError = this.$t('L_calculator_dob_min_error');
          this.currentAge = '';
        } else if (age > 100) {
          this.isDobValid = false;
          this.dobError = this.$t('L_calculator_dob_max_error');
          this.currentAge = '';
        } else {
          this.currentAge = '' + age;
          this.isDobValid = true;
          this.validateAge();
        }
      }
    },
    validateAmt() {
      if (!this.scenario.currentIncome) {
        this.scenario.incomeGoalPct = 0;
        this.isPctValid = true;
        return;
      }
      this.scenario.incomeGoalPct = +(
        ((this.scenario.incomeGoal * this.scenario.incomePeriod) / this.scenario.currentIncome) *
        100
      ).toFixed(2);
      this.isPctValid = this.scenario.incomeGoalPct <= 1000;
    },
    viewMyInvestments() {
      this.$emit('open');
    },
    onDateUpdate(newValue: Date | undefined) {
      this.dateOfBirth = newValue ?? null;
    },
  },
  mounted() {
    const storedDob = this.investments.calculator?.scenario?.dateOfBirth;
    if (storedDob) {
      this.dateOfBirth = parseISO(storedDob);
    }
    if (!this.investments.calculator.projection) {
      this.calculate('init');
    } else {
      this.selectedAccounts = [];
      this.scenario?.retirement?.accounts?.forEach(
        (account: IInvestmentCalculatorScenarioRetirementAccount) => {
          if (account.enabled) this.selectedAccounts.push(account.number);
        }
      );
    }
    if (this.customerProfile.country === COUNTRIES.CANADA) {
      this.socialSecurityBenefits = window.appConfig.investments.social_security_benefits.ca;
    }
    this.expandedPrediction = !this.hidePredictionDetails;
  },
  watch: {
    hidePredictionDetails(newData) {
      this.expandedPrediction = !newData;
    },
    dateOfBirth(newData, oldData) {
      this.dobError = '';
      this.validateDob();
      const newTime = newData instanceof Date ? newData.getTime() : null;
      const oldTime = oldData instanceof Date ? oldData.getTime() : null;
      if (newTime !== oldTime) {
        if (!this.dobError) {
          this.calculate('dob');
        }
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.blackText {
  color: #000000;
}
#retirement-calculator {
  background: #ffffff;
  #birth_date-messages {
    display: none;
  }
  .congratulations {
    color: #333333;
  }
  .view-mode-details {
    color: #063562;
  }
  .retirement-title {
    background-color: #e3e3e3;
  }
  .account-list {
    background-color: #f5f5f5;
  }
  .v-label {
    display: block !important;
  }
  .v-tooltip__content {
    pointer-events: initial;
  }
  .unit {
    font-size: 12px;
  }
  .chart {
    display: inline-block;
  }
  .pct-of-recommended {
    display: none !important;
  }
  .your-coverage {
    display: none !important;
  }
  .heading_four {
    display: none !important;
  }
  .color-light-black {
    display: none !important;
  }
  .pill-text-field {
    height: 55px;
    border-radius: 39px;
    background-color: #ffffffc0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    font-weight: bold;
  }
  .pill-text-field-red {
    height: 55px;
    border-radius: 39px;
    background-color: #ffffffc0;
    border: solid 1px #d96154;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    font-weight: bold;
  }
  .titlebox {
    background-color: #dcdcdc;
  }
  .rule-of-thumb-card {
    background-color: #f5f5f5;
  }
  .doughnut-chart {
    background-color: red;
  }
  .estimate-social-security {
    color: #02579e;
  }
  .link {
    font-weight: 600;
    color: #02579e;
    cursor: pointer;
  }
  a.primary--text {
    color: #e5e9ec !important;
    caret-color: #f4f4f4 !important;
  }
  ul li {
    margin: 10px;
  }
  .v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
  .v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .v-text-field__slot input {
    text-align: center;
  }
  .progress-circle {
    background-color: #ffffff;
    &:after {
      background-color: #d8d8d8;
    }

    .left-half-clipper {
      .value-bar {
        border: 0.5em solid #0b8d1f;
      }

      .first50-bar {
        background-color: #0b8d1f;
      }

      &:not(.over50) {
        .first50-bar {
          background-color: #ffffff !important;
        }
      }
    }
    > .display {
      color: #333333;
      background-image: none;
    }
  }
  .more-padding {
    .v-text-field__slot input {
      padding: 0px !important;
    }
  }
  #percentage-guidence-calculator {
    padding-top: 0;
  }
}
.text-size-sm {
  font-size: 11px !important;
}
#retirement-calculator-age-input,
#percentage-guidence-calculator {
  text-align: center !important;
}
</style>
